import { Button } from 'tradera/components/atoms/button/button';
import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import WarningIcon from '@tradera/blueprint/theme/icons2/alert.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import { TextBox } from 'tradera/components/form-controls/text-box/text-box';

type NewMessageFormProps = {
    onClose: () => void;
    onSubmit: SubmitHandler<IFormInputs>;
    isError: boolean;
};

export type IFormInputs = {
    messageText: string;
};

export const NewMessageForm = ({
    isError,
    onSubmit,
    onClose,
}: NewMessageFormProps) => {
    const { t } = useTranslator();

    const {
        register,
        handleSubmit: handleSubmitHook,
        formState: { isSubmitting, isValid },
    } = useForm<IFormInputs>({
        defaultValues: {
            messageText: '',
        },
        mode: 'onChange',
    });
    return (
        <div className="mt-2">
            <form onSubmit={handleSubmitHook(onSubmit)}>
                <TextBox
                    placeholder={t(
                        'messaging_new_message_modal_textPlaceholder',
                    )}
                    {...register('messageText', { required: true })}
                />
                <div className="d-flex mt-1 align-items-center mb-3">
                    <WarningIcon className="icon icon-sm mr-1 flex-shrink-0 icon-gray-600" />
                    <span className="size-oslo color-gray-600">
                        {t('messaging_new_message_modal_warningText')}
                    </span>
                </div>
                {isError ? (
                    <p
                        role="alert"
                        className="text-danger"
                        aria-live="assertive">
                        <small>
                            {t('messaging_new_message_modal_genericErrorText')}
                        </small>
                    </p>
                ) : null}
                <div className="d-flex justify-content-center justify-content-md-end mt-1">
                    <Button
                        theme="primary"
                        fluid
                        variant="outline"
                        className="mr-1 px-5 flex-grow-1 flex-md-grow-0"
                        onClick={onClose}>
                        {t('messaging_new_message_modal_cancelButtonText')}
                    </Button>
                    <Button
                        theme="primary"
                        fluid
                        type="submit"
                        className="ml-1 px-5 flex-grow-1 flex-md-grow-0"
                        loading={isSubmitting}
                        disabled={!isValid}>
                        {t('messaging_new_message_modal_submitButtonText')}
                    </Button>
                </div>
            </form>
        </div>
    );
};
